<template>
  <div
    :id="`prompt-actions-${source}-${row.id}`"
    class="flex items-center justify-center w-full h-full"
  >
    <a-dropdown :trigger="['click']" placement="bottomRight">
      <div
        class="cursor-pointer p-1 rounded action_icon_hover"
        @click.stop
      >
        <ThemeImage
          :icon="imageNames.MORE_VERTICAL"
          alt="actions"
          class="size-5"
        />
      </div>
      <template #overlay>
        <a-menu>
          <a-menu-item key="delete" @click="handleDelete">
            <div class="flex items-center gap-2">
              <ThemeImage
                :icon="imageNames.DELETE_GREY"
                alt="delete"
                class="size-4"
              />
              <span>Delete</span>
            </div>
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script setup>
import { imageNames } from "@/src/constants/imageConstants.js";
import ThemeImage from "@/src/components/ThemeImage.vue";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  row: { type: Object, required: true },
  source: { type: String, default: "recommended-leads" },
});

const handleDelete = () => {
  eventBus.emit("delete-recommended-lead", { id: props.row.id });
};
</script>

<style scoped>
.action_icon_hover:hover {
  background-color: var(--white-opacity-8);
}
</style>

